import { render } from "./CompoundScopeView.vue?vue&type=template&id=2ec1d72c&scoped=true"
import script from "./CompoundScopeView.vue?vue&type=script&lang=js"
export * from "./CompoundScopeView.vue?vue&type=script&lang=js"

import "../styles/CompoundScopeView.scss?vue&type=style&index=0&id=2ec1d72c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec1d72c"]])

export default __exports__